import React from 'react';
import UHCSidebarFooter from '../../../../../../Dumb/Atoms/Sidebar/Fotter/Footer';
import UHCContractButton, { UHCContractButtonProps } from '../../../../../Atoms/Server/Contract/Sidebar/ContractButton/ContractButton';
import { UHCSidebarServerContractProps } from '../../../../Server/Contract/Sidebar/Sidebar.interface';
import { PriceTotalFooter, SidebarButtonFooter, StyledUHCPriceTotal } from './Footer.styled';

export interface UHCSidebarFooterServerContract {
    profileSelected: UHCSidebarServerContractProps['profileSelected']
    onClick: UHCContractButtonProps['onClick']
}

const UHCSidebarContractFooter: React.FC<UHCSidebarFooterServerContract> = ({ profileSelected, onClick }: UHCSidebarFooterServerContract) => {
    return (
        <UHCSidebarFooter>
            <PriceTotalFooter>
                <StyledUHCPriceTotal profileSelected={profileSelected} />
            </PriceTotalFooter>
            <SidebarButtonFooter>
                <UHCContractButton onClick={(e) => { onClick(e) }} />
            </SidebarButtonFooter>
        </UHCSidebarFooter>
    )
}

export default UHCSidebarContractFooter;